// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_feJ","cls2":"PaperAbstract-cls2_RVx PaperAbstract-cls1_feJ"};